import { LatLngExpression, latLngBounds } from 'leaflet';
import { isEmpty } from 'lodash-es';
import { computed, watch } from 'vue';
import { usePlacesStore } from '../stores';
import { storeToRefs } from 'pinia';
import { useMapStore } from '@/features/map/stores';

export function useFromToPlaces() {
    const placesStore = usePlacesStore();
    const { fromPlace, toPlace } = storeToRefs(placesStore);
    const { bounds } = storeToRefs(useMapStore());

    const fromToPlaceBounds = computed(() => {
        const latLngs: LatLngExpression[] = [fromPlace.value, toPlace.value]
            .filter(p => !!p && !isEmpty(p?.coordinates))
            .map(p => ({ lat: p!.coordinates!.latitude, lng: p!.coordinates!.longitude }));
        if (latLngs.length === 0) return null;

        const bounds = latLngs.reduce(
            (bounds, latLng) => {
                return bounds.extend(latLng);
            },
            latLngBounds(latLngs[0], latLngs[0])
        );

        return bounds.isValid() ? bounds : null;
    });

    watch(
        fromToPlaceBounds,
        value => {
            if (value && value.isValid() && !bounds.value.equals(value)) {
                bounds.value = value;
            }
        },
        {
            immediate: true
        }
    );
}
